import { useMutation } from '@tanstack/react-query';
import type { UseMutateFunction } from '@tanstack/react-query';
import { useMessage } from './useMessage';
import { getFilePresignedUrlApi } from './useDownloadFile';

export const GET_FILE_VIEW_URL_KEY = 'getFileViewUrl';

interface IViewFileParams {
  fileId: string;
  modelInstanceId: string;
}

export const useViewFile = (onSuccess?: (url: string) => void) => {
  const message = useMessage();

  const {
    mutate,
    isPending: isLoadingFile,
    error: errorLoadingFile,
  } = useMutation<string, Error, IViewFileParams>({
    mutationKey: [GET_FILE_VIEW_URL_KEY],
    mutationFn: ({ fileId, modelInstanceId }) =>
      getFilePresignedUrlApi(fileId, modelInstanceId),
    onSuccess: url => {
      if (onSuccess) {
        onSuccess(url);
      }
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.title ||
        error?.message ||
        'Failed to load file';
      message.error(errorMessage);
    },
  });

  const viewFile: UseMutateFunction<string, Error, IViewFileParams, unknown> =
    mutate;

  return {
    viewFile,
    isLoadingFile,
    errorLoadingFile,
  };
};
